"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21haW4vbWFwL2RldGFpbC12aWV3cy9sYXllcnMvZmVhdHVlci1wcm9wZXJ0aWVzLXZpZXdlci9mZWF0dWVyLXByb3BlcnRpZXMtdmlld2VyLmNvbXBvbmVudC5zY3NzIn0= */"];
exports.styles = styles;
